<script lang="ts">
    import { createSlider } from '@melt-ui/svelte';

    export let defaultMin: number | undefined, defaultMax: number | undefined;
    export let label: string;
    export let valueMin: number;
    export let valueMax: number;

    const {
        elements: { root, range, thumbs },
        states: { value },
    } = createSlider({
        defaultValue: [valueMin, valueMax],
        max: defaultMax,
        min: defaultMin,
        onValueChange: ({ next }) => {
            valueMin = next[0];
            valueMax = next[1];

            return next;
        },
    });

    $: {
        // watch valueMin an valueMax if parent component change them
        $value = [valueMin, valueMax];
    }
</script>

<div class="flex flex-col">
    <span
        {...$root}
        use:root
        class="relative m-auto flex h-[40px] w-full items-center"
    >
        <span class="h-[2px] w-full bg-bord-quiet">
            <span {...$range} use:range class="h-[2px] bg-content-quiet" />
        </span>

        {#each $thumbs as thumb}
            <span
                {...thumb}
                use:thumb.action
                class="focus:ring-m relative size-m cursor-pointer rounded-full bg-content-quiet focus:!ring-content-quiet"
            >
            </span>
        {/each}
    </span>
    <div class="flex justify-between">
        <div class="flex gap-xs">
            <input
                class="!max-w-[100px] border-border-quiet"
                value={valueMin}
                type="number"
                on:input={(event) => {
                    valueMin = event.target?.value;
                    $value[0] = valueMin;
                }}
            />
            <span class="self-center">{label}</span>
        </div>
        <div class="flex gap-xs">
            <input
                class="!max-w-[100px] border-border-quiet"
                value={valueMax}
                type="number"
                on:input={(event) => {
                    valueMax = event.target?.value;
                    $value[1] = valueMax;
                }}
            />
            <span class="self-center">{label}</span>
        </div>
    </div>
</div>
